<template>
  <v-container class="main-container responsive-height">
    <v-row>
      <v-col md="6" sm="6" lg="4" v-for="method in methods" :key="method.id">
        <v-card class="elevation-0 rounded-0 transition-method-card"
          :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
          <v-card-actions class="paymentImage">
            <v-img height="155" contain :src="getMethodImage(method.method_name)" :alt="method.method_name">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-card-actions>
          <v-card-actions>
            <div class="value">
              <span>Method</span>
              <span>{{ method.method_name }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="value">
              <span>Currency</span>
              <span>{{ getCurrencyName(method.currency_id) }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <div class="value">
              <span>Processing Time</span>
              <span>{{ method.processing_time }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="value mr-6">
              <span>Fees</span>
              <span>${{ method.commission }}</span>
            </div>
          </v-card-actions>

          <v-card-actions class="pb-0 pt-3">
            <v-dialog transition="scale-transition" origin="center center" max-width="554"
              content-class="deposit-withdraw-popup">
              <template v-slot:activator="{ on, attrs }">
                <v-btn tile outlined elevation="0" class="text-capitalize btn-account" color="greenMain" v-bind="attrs"
                  v-on="on">Details</v-btn>
              </template>
              <template v-slot:default="dialog">
                <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                  <v-card-title class="rounded-0">{{ method.method_name }} Detail</v-card-title>
                  <p>
                    <p class="display"><span>Currency:</span> <span>{{ getCurrencyName(method.currency_id) }}</span></p>
                    <p class="display"><span>Fees / Commission:</span> <span>${{ method.commission }}</span></p>
                    <p class="display"><span>Processing Time:</span> <span>{{ method.processing_time }}</span></p>

                    <span v-if="method.method_name == 'Bank Transfer'" class="mb-3" v-for="(bank,index) in banks" :key="index">
                      <p class="hash-name">#{{ index+1 }}</p>
                      <p class="display"><span>Broker Bank Name:</span> <span>{{ bank.bank_name || "N/A" }}</span></p>
                      <p class="display"><span>Account  Name:</span> <span>{{ bank.bank_acc_name || "N/A" }}</span></p>
                      <p class="display"><span>Account Number:</span> <span>{{ bank.bank_acc_num || "N/A" }}</span> </p>
                      <p class="display"><span>SWIFT Code:</span> <span>{{ bank.bank_swift_num || "N/A" }}</span></p>
                      <p class="display"><span>IBAN Number:</span> <span>{{ bank.bank_iban_num || "N/A" }}</span></p>
                      <p class="display"><span>Bank Country:</span> <span>{{ bank.bank_residence_country || "N/A" }}</span></p>
                      <p class="display"><span>City:</span> <span>{{ bank.city_country || "N/A" }}</span></p>
                      <p class="display"><span>State:</span> <span>{{ bank.bank_residence_state || "N/A" }}</span></p>
                      <p class="display"><span>Postal Code:</span> <span>{{ bank.bank_postal_code || "N/A" }}</span></p>
                      <p class="display"><span>Bank Address:</span> <span>{{ bank.bank_address || "N/A" }}</span></p>
                    </span>

                    <span v-if="method.method_name == 'Crypto'" class="mb-3" v-for="(crypto,index) in addresses" :key="index">
                      <p class="hash-name">#{{ index+1 }}</p>
                      <p class="display"><span>Crypto Network:</span> <span>{{ crypto.renamedAddress || "N/A" }}</span></p>
                      <p class="display"><span>Crypto Address:</span> <span>{{ crypto.address || "N/A" }}</span></p>
                    </span>
                  </p>
                </v-card>
              </template>
            </v-dialog>

            <v-btn :to="getUrl(method)" tile elevation="0" class="text-capitalize btn-account"
              color="greenMain">Select</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-card-text v-if="methods.length == 0" class="text-center">No Payment Methods Available</v-card-text>
    </v-row>
    <verify-gate-dialog />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { WITHDRAWMETHODS__ACTIONS } from "@/store/action-types";
import VerifyGateDialog from '@/components/Alert/VerifyGateDialog.vue'

export default {
  components: {
    VerifyGateDialog,
  },

  data: () => ({
    methodImages: {
      'Bank Transfer': require("@/assets/payments/bank.png"),
      'Cash Transfer': require("@/assets/payments/cash.png"),
      'Crypto': require("@/assets/payments/crypto.png"),
      'MAM Withdraw': require("@/assets/payments/mam-withdraw.png"),
    },
    currencyMap: {
      1: 'USD',
      2: 'EUR',
      3: 'USDT'
    }
  }),
  
  computed: {
    ...mapState("withdraw", ["methods", "banks", "addresses"])
  },
  methods: {
    ...mapActions("withdraw", [
      WITHDRAWMETHODS__ACTIONS.WITHDRAWMETHODS,
      WITHDRAWMETHODS__ACTIONS.BROKERSBANK,
      WITHDRAWMETHODS__ACTIONS.USERCRYPTOADDRESS
    ]),
    getMethodImage(methodName) {
      return this.methodImages[methodName] || '';
    },
    getUrl(method) {
      return method.method_name === 'Bank Transfer' ? `/bank-withdraw?payment_id=${method.id}` 
      : method.method_name === 'MAM Withdraw' ? `/mam-withdraw?payment_id=${method.id}`
      : `/crypto-withdraw?payment_id=${method.id}`
    },
    getCurrencyName(currencyId) {
      return this.currencyMap[currencyId] || 'USD';
    },
    formatMaxAmount(amount) {
      return Number(amount).toLocaleString();
    }
  },
  async mounted() {
    await this[WITHDRAWMETHODS__ACTIONS.WITHDRAWMETHODS]();
    await this[WITHDRAWMETHODS__ACTIONS.BROKERSBANK]();
    await this[WITHDRAWMETHODS__ACTIONS.USERCRYPTOADDRESS]();
  }
};
</script>
<style>
.display{
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}

.hash-name{
  color: #0392D9 !important;
  font-weight: 900 !important;
  font-size: 14 !important;
}
</style>